import React from 'react';
import { useNavigate } from 'react-router-dom';
import { translate, Translate } from 'react-jhipster';
import { Box } from '@mui/system';
import { WizardStepper } from 'app/components/stepper/WizardStepper';
import { FormStepper } from 'app/components/stepper/form-stepper/FormStepper';
import { sitemap } from 'app/shared/util/url-utils';
import { userProfilesApi } from 'app/store/reducers/api/config-manager-cloud-services/store/user-profiles';
import {
  accountProfileApi,
  useUpdateCurrentAccountDetailsMutation,
} from 'app/store/reducers/api/config-manager-cloud-services/store/account-profiles';
import { FieldProp } from 'app/modules/form-builder-lib';
import { AccountStatus } from 'app/store/reducers/api/config-manager-cloud-services/store/types';
import { useUpdateCurrentBillingProfileMutation } from 'app/store/reducers/api/config-manager-cloud-services/store/billing-profile';

export const WelcomeFormStepper = () => {
  const navigate = useNavigate();
  const [updateAccount] = useUpdateCurrentAccountDetailsMutation();
  const [updateBilling] = useUpdateCurrentBillingProfileMutation();

  const accountFields: FieldProp[] = [
    {
      component: 'text-field',
      label: 'Name',
      attribute: 'name',
      validationType: 'string',
      validations: [['required', true]],
    },
    {
      component: 'text-field',
      label: translate('welcome.form.company', null, 'Company'),
      attribute: 'company',
      validationType: 'string',
    },
    {
      component: 'text-field',
      label: translate('welcome.form.email', null, 'Email'),
      attribute: 'email',
      validationType: 'string',
      validations: [['email', true]],
    },
    {
      component: 'text-field',
      label: translate('welcome.form.phone', null, 'Phone'),
      attribute: 'phone',
      validationType: 'string',
    },
  ];

  const billingFields: FieldProp[] = [
    {
      component: 'text-field',
      label: translate('welcome.form.address', null, 'Address'),
      attribute: 'address1',
      validationType: 'string',
    },
    {
      component: 'text-field',
      label: translate('welcome.form.country', null, 'Country'),
      attribute: 'country',
      validationType: 'string',
    },
    {
      component: 'text-field',
      label: translate('welcome.form.city', null, 'City'),
      attribute: 'city',
      validationType: 'string',
    },
    {
      component: 'text-field',
      label: translate('welcome.form.postalCode', null, 'Postal Code'),
      attribute: 'postalCode',
      validationType: 'string',
    },
  ];

  const steps = [
    {
      label: 'Set Account Details',
      children: ({ stepperState }) => (
        <FormStepper
          fields={accountFields}
          defaultValues={{
            name: null,
          }}
          onSubmit={data => {
            updateAccount({
              updates: {
                name: data.name,
                company: data.company,
                email: data.email,
                phone: data.phone,
                status: AccountStatus.ACTIVE,
              },
            }).unwrap();
            stepperState.methods.handleNext();
          }}
          submitFormText={'Next'}
        />
      ),
    },
    {
      label: <Translate contentKey="welcome.billing-details">Billing Details</Translate>,
      children: ({ stepperState }) => (
        <FormStepper
          fields={billingFields}
          defaultValues={{
            address1: '',
          }}
          onSubmit={data => {
            updateBilling({
              billingUpdates: {
                country: data.country,
                address1: data.address1,
                city: data.city,
                postalCode: data.postalCode,
              },
            })
              .unwrap()
              .then(() => {
                navigate(sitemap.home);
              });
          }}
          submitFormText={'Finish'}
        />
      ),
    },
  ];

  return (
    <Box display="flex">
      <Box sx={{ mx: 'auto', width: '70%', my: 4 }}>
        <WizardStepper steps={steps} orientation="horizontal" />
      </Box>
    </Box>
  );
};
